module.exports = __webpack_public_path__ + "static/media/social2.9e89b9dc.svg";